<mat-icon *ngIf="iconStatus && !rerunning" [ngClass]="iconStatus.classname">{{iconStatus.icon}}</mat-icon>
<mat-progress-spinner *ngIf="rerunning" [diameter]="20" mode="indeterminate" color="accent"></mat-progress-spinner>
